import styled from "styled-components"
import Container from "@material-ui/core/Container"

const StaticContainer = styled(Container)`
  margin: auto;
  padding: 1rem 1.5rem;
`
export default StaticContainer
